import React from "react";
import './Footer.css'
import Wave from '../../assets/wabeok.png';
import Linkedin from "@iconscout/react-unicons/icons/uil-linkedin";
import { UilEnvelopeAlt } from '@iconscout/react-unicons'
import Gitub from "@iconscout/react-unicons/icons/uil-github";
import {motion} from 'framer-motion';
import {Link} from 'react-scroll';
import { useTranslation } from "react-i18next"; //translator

const Footer = () =>{
  const[t] = useTranslation("global");
    return(
        <div className="footer">
        <img className="wave" src={Wave} alt="" style={{ width: "100%" , height: "300px"}} />
        <div className="f-content">
          <span></span>
          <div className="f-icons">
                    <motion.a 
                      whileHover={{ scale: 1.2, rotate: 15 }}
                      whileTap={{ scale: 0.8, rotate: -15 }} 
                     target="_blank"
                     rel="noreferrer" 
                     href="https://www.linkedin.com/in/sol-olmos-fullstackdev-industrialdesigner/">
                    <Linkedin color="white" size={"3rem"} />
                    </motion.a>

                    <motion.a 
                      whileHover={{ scale: 1.2, rotate: 15 }}
                      whileTap={{ scale: 0.8, rotate: -15 }} 
                     target="_blank"
                     rel="noreferrer" 
                     href="https://github.com/sololmos">
                     <Gitub color="white" size={"3rem"} />
                    </motion.a>  

                    <motion.a 
                      whileHover={{ scale: 1.2, rotate: 15 }}
                      whileTap={{ scale: 0.8, rotate: -15 }} 
                     target="_blank"
                     rel="noreferrer" 
                     href="mailto:mariasol039@hotmail.com">
                     <UilEnvelopeAlt color="white" size={"3rem"} />
                    </motion.a>

          </div>
          <span>
            {t("Footer.description")} - 
            <Link spy={true} to='Intro'smooth={true} activeClass='activeClass' >
             <b style={{ cursor: 'pointer'}}> Sol Olmos</b>
            </Link>
           
          </span>
        </div>
      </div>
    );
};

export default Footer;